// Application constants
const CONFIG = {
  API_URL: 'https://api.lichic.dev.innvonix.in/api',
  WEB_URL: 'https://lichic.dev.innvonix.in',
  MEDIA_BASE_URL: 'https://api.lichic.dev.innvonix.in',
  RECORDS_PER_PAGE: 10, // For lazy loading
  GOOGLE_OAUTH_CLIENT_ID: "674648950958-f989pjj2c5pjvlbqu0hsv66g4qd1igi6.apps.googleusercontent.com",
  GOOGLE_OAUTH_CLIENT_SECRET: "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"
};

export default CONFIG;
